<template lang="html">
  <div>
    <v-btn v-if="isLikedByUser(el.likes)" text color="blue" @click="$emit('unlikeClick', el)">
      <v-icon class="mr-5">thumb_up</v-icon>
      {{el.likes.length}}
    </v-btn>
    <v-btn v-else text color="grey" @click="$emit('likeClick', el)">
      <v-icon class="mr-5">thumb_up</v-icon>
      {{el.likes.length}}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'StandardLikeBtn',
  props: ['el', 'curr_user_id'],
  methods: {
    isLikedByUser: function(likes) {
      if (likes.some(like => like.user.id === this.curr_user_id)) {
        return true;
      }
      return false;
    },
  }
}
</script>

<style lang="css" scoped>
</style>
